// export enum NOTIFICATION_TYPE {
//   TEXT = 1,
//   INTERNAL_NOTIFICATION = 2,
//   FILE = 3,
//
//   TICKET = 4,
//   TICKET_ADDRESS_CHANGE = 5,
//   TICKET_CREATED_PENDING_RECEPTION = 6,
//   TICKET_CREATED_SUPERVISOR = 7,
//
//   TICKET_HOLD_MANAGER = 8,
//   TICKET_COLLABORATION_CLOSED = 9,
//   TICKET_COLLABORATION_SENT = 10,
//   TICKET_CLOSED = 11,
//   TICKET_UPDATED = 12,
//   TICKET_RECEIVED = 13,
//   TICKET_RETURN_TTCSKH = 14
// }


export enum NOTIFICATION_TYPE {
  TEXT = 1,
  INTERNAL_NOTIFICATION = 2,
  FILE = 3,

  TICKET = 4,

  TICKET_ADDRESS_CHANGE = 5,
  TICKET_CREATED_PENDING_RECEPTION = 6,
  TICKET_CREATED_SUPERVISOR = 7,

  TICKET_HOLD_MANAGER = 8,
  TICKET_COLLABORATION_CLOSED = 9,
  TICKET_COLLABORATION_SENT = 10,
  TICKET_CLOSED = 11,
  TICKET_UPDATED = 12,
  TICKET_RECEIVED = 13,
  TICKET_RETURN_TTCSKH = 14,

  TICKET_CLOSED_BY_TTCSKH = 15,
  TICKET_TRANSFER_SUPPORT_UNIT = 16,
}
